import {Plural, Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../components/common/dialogs/okCancelDialog';
import {CustomFieldModel} from '../../../models/api/customFieldModel';
import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';
import {CustomFieldsResourceName} from '../list/customFieldsResourceName';

/*
 * Props.
 */

interface CustomFieldsDeleteDialogProps {
  customFields: ReadonlyArray<CustomFieldModel>;
  tabPage: SettingsCustomFieldsPagesEnum;
  onClose: Handler;
  onDelete: Handler;
}

/*
 * Styles.
 */

const StyledOkCancelDialog = styled(OkCancelDialog)`
  margin: 0 16px;
`;

/*
 * Component.
 */

export const CustomFieldsDeleteDialog: FC<CustomFieldsDeleteDialogProps> = (props) => {
  const {customFields, tabPage, onClose, onDelete} = props;
  const resourceName = CustomFieldsResourceName({
    tabPage,
  });

  return (
    <StyledOkCancelDialog
      title={renderTitle(customFields)}
      okButtonLabel={
        <Trans id="delete-custom-fields-confirmation-dialog-delete-permanently">Delete permanently</Trans>
      }
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={onClose}
      onOkClick={onDelete}
    >
      <Plural
        id="delete-custom-fields-confirmation-dialog-description"
        value={customFields.length}
        one={`Permanently deleting this field will remove it from all ${resourceName}. This action cannot be undone.`}
        other={`Permanently deleting these fields will remove them from all ${resourceName}. This action cannot be undone.`}
      />
    </StyledOkCancelDialog>
  );
};

/*
 * Helpers.
 */

function renderTitle(customFields: ReadonlyArray<CustomFieldModel>) {
  return (
    <Plural
      id="delete-custom-fields-confirmation-dialog-title"
      value={customFields.length}
      one={`Delete "${customFields[0].name}" custom field`}
      other="Delete # custom fields"
    />
  );
}
